import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Check, X, Loader2 } from "lucide-react";
import { api } from "../lib/api";
import { useCart } from "../context/CartContext";

export default function PaymentCallback() {
  const [params] = useSearchParams();
  const reference = params.get("reference") || params.get("trxref");
  const [status, setStatus] = useState("verifying");
  const { clear } = useCart();

  useEffect(() => {
    if (!reference) { setStatus("failed"); return; }
    api.get(`/checkout/paystack/verify/${reference}`)
      .then(({ data }) => {
        if (data.status === "success") { clear(); setStatus("success"); }
        else setStatus("failed");
      })
      .catch(() => setStatus("failed"));
  }, [reference, clear]);

  return (
    <div className="min-h-screen bg-[#050806] grid place-items-center p-6" data-testid="payment-callback">
      <div className="text-center max-w-md">
        {status === "verifying" && (
          <>
            <Loader2 size={48} className="mx-auto text-emerald-400 animate-spin" />
            <h1 className="font-display text-4xl text-white mt-5">VERIFYING PAYMENT…</h1>
          </>
        )}
        {status === "success" && (
          <>
            <div className="w-16 h-16 mx-auto grid place-items-center rounded-full bg-emerald-500 text-emerald-950"><Check size={32} /></div>
            <h1 className="font-display text-4xl text-white mt-5">PAYMENT SUCCESSFUL!</h1>
            <p className="text-gray-300 mt-2">Thank you, hero. Your order <span className="text-emerald-400 font-mono">{reference}</span> is confirmed.</p>
            <Link to="/merch" className="inline-block btn-skew bg-emerald-500 text-emerald-950 font-accent text-xl px-8 py-3 mt-7"><span>Continue Shopping</span></Link>
          </>
        )}
        {status === "failed" && (
          <>
            <div className="w-16 h-16 mx-auto grid place-items-center rounded-full bg-red-500 text-white"><X size={32} /></div>
            <h1 className="font-display text-4xl text-white mt-5">PAYMENT NOT CONFIRMED</h1>
            <p className="text-gray-300 mt-2">We couldn&rsquo;t verify this payment. If you were charged, contact us with reference {reference}.</p>
            <Link to="/checkout" className="inline-block btn-skew bg-emerald-500 text-emerald-950 font-accent text-xl px-8 py-3 mt-7"><span>Back to Checkout</span></Link>
          </>
        )}
      </div>
    </div>
  );
}
